import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import emojione from 'emojione';
import App from './App';

window.emojione = emojione;

Vue.use(VeeValidate, { events: '', fieldsBagName: 'veeFields' });
Vue.use(BootstrapVue);

Vue.prototype.$env = {
  MIX_API_URL: process.env.MIX_API_URL,
};

Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
});
